import { combineReducers } from "redux";
import authReducer from "./authReducer";
import globalReducer from "./globalReducer";
import successReducer from "./successReducer";
import errorReducer from "./errorReducer";

export default combineReducers({
  auth: authReducer,
  global: globalReducer,
  success: successReducer,
  errors: errorReducer,
});
